import { VendorDetailPage } from "../vendor-detail.page";
import { useCentralStore } from "../../../store/Central";

export const VendorDetailPageConnected = () => {
	const organizationId = useCentralStore((s) => s.organization?.id ?? "");
	return <VendorDetailPage customerOrgId={organizationId} />;
};
